/**
 * Deafult Shader for Image Tiles, with Texture Gamma-Correction.
 */
export class CustomShader {
}
CustomShader.tileVertexShader = "varying vec2 vTexCoord;\n" +
    "\n" +
    "void main()\n" +
    "{\n" +
    "   gl_Position =   projectionMatrix * modelViewMatrix * vec4(position,1.0);\n" +
    "   vTexCoord = uv;\n" +
    "}\n";
CustomShader.tileFragmentShader = "#ifdef GL_ES\n" +
    "   precision highp float;\n" +
    "#endif\n" +
    "   varying vec2 vTexCoord;\n" +
    "   uniform sampler2D uTexture;\n" +
    "   uniform float uGamma;\n" +
    "   uniform float uOpacity;\n" +
    "   void main()\n" +
    "   {\n" +
    "      vec4 color = texture2D(uTexture, vTexCoord);\n" +
    "	    color.rgb = vec3(pow(color.r,1.0/uGamma), pow(color.g,1.0/uGamma), pow(color.b,1.0/uGamma));\n" +
    "      gl_FragColor = vec4(color.rgb,uOpacity);\n" +
    "   }\n";
CustomShader.panoTileVertexShader = "varying vec2 vTexCoord; varying vec4 pos;\n" +
    "\n" +
    "void main()\n" +
    "{\n" +
    "   gl_Position =   projectionMatrix * modelViewMatrix * vec4(position,1.0);\n" +
    "   vTexCoord = uv;\n" +
    "   pos = modelMatrix * vec4(position,1.0);\n" +
    "}\n";
CustomShader.panoTileFragmentShader = "#ifdef GL_ES\n" +
    "   precision highp float;\n" +
    "#endif\n" +
    "   varying vec2 vTexCoord;\n" +
    "   uniform sampler2D uTexture;\n" +
    "   uniform float uGamma;\n" +
    "   uniform float fCalloteId;\n" +
    "   uniform float fLod;\n" +
    "   uniform float fSmear;\n" +
    "   varying vec4 pos;\n" +
    "   vec3 getNormal(vec3 p1, vec3 p2, vec3 p3)\n" +
    "   {\n" +
    "     return normalize(cross(p2-p3,p1-p3));\n" +
    "   }\n" +
    "   float getDistanceToPlane(vec3 normal,vec3 p)\n" +
    "   {\n" +
    "     return abs(dot(normal,p));\n" +
    "   }\n" +
    "   void main()\n" +
    "   {\n" +
    "      vec4 color = texture2D(uTexture, vTexCoord);\n" +
    "	     color.rgb = vec3(pow(color.r,1.0/uGamma), pow(color.g,1.0/uGamma), pow(color.b,1.0/uGamma));\n" +
    "      float t = 0.6;\n" +
    "      float b = 0.8;\n" +
    "      float tv = 0.1;\n" + //vertical thresholds
    "      float bv = 0.2;\n" +
    //---
    "      vec3 n1 = getNormal(vec3(-3.2920162781916265,4.697869587817501,-4.56282541970637),vec3(3.3943437620579395,4.670196930840324,-4.547895271645863),vec3(0.0,0.0,0.0));\n" +
    "      float d1 = getDistanceToPlane(n1,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d1<t && fCalloteId==5.0){color.a = min(d1/b,color.a);}\n" +
    //---
    "      vec3 n2 = getNormal(vec3(-5.400553004398935,4.676452564455412,1.8704072995935226),vec3(-3.2753564447220307,4.70549386321915,-4.560097450496714),vec3(0.0,0.0,0.0));\n" +
    "      float d2 = getDistanceToPlane(n2,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d2<t && fCalloteId==5.0){color.a = min(d2/b,color.a);}\n" +
    //---
    "      vec3 n3 = getNormal(vec3(0.06180338539763388,4.655212083578905,5.793720335702465),vec3(-5.407921721713153,4.678521982738233,1.8540526235831827),vec3(0.0,0.0,0.0));\n" +
    "      float d3 = getDistanceToPlane(n3,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d3<t && fCalloteId==5.0){color.a = min(d3/b,color.a);}\n" +
    //---
    "      vec3 n4 = getNormal(vec3(5.255050766225611,4.736596774483118,2.0631835348394327),vec3(0.07037269032742763,4.66016625269938,5.786542634027902),vec3(0.0,0.0,0.0));\n" +
    "      float d4 = getDistanceToPlane(n4,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d4<t && fCalloteId==5.0){color.a = min(d4/b,color.a);}\n" +
    //---
    "      vec3 n5 = getNormal(vec3(3.405689640079391,4.687526909730635,-4.51034511246803),vec3(5.388167293163876,4.697482113371865,1.9335864191770715),vec3(0.0,0.0,0.0));\n" +
    "      float d5 = getDistanceToPlane(n5,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d5<t && fCalloteId==5.0){color.a = min(d5/b,color.a);}\n" +
    //--vertical 4-0
    "      vec3 n6 = getNormal(vec3(-3.0083366768971467,4.997416872666556,-4.180032028567553),vec3(-2.7257036216037673,-6.281519263433309,-3.7265358724774007),vec3(0.0,0.0,0.0));\n" +
    "      float d6 = getDistanceToPlane(n6,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d6<tv && fCalloteId==4.0){color.a = min(d6/bv,color.a);}\n" +
    //--vertical 3-4
    "      vec3 n7 = getNormal(vec3(-5.406648379300367,4.6688572701635405,1.8680673107605565),vec3(-4.421282445613405,-6.309623534140252,1.5034506996454404),vec3(0.0,0.0,0.0));\n" +
    "      float d7 = getDistanceToPlane(n7,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d7<tv && fCalloteId==4.0){color.a = min(d7/bv,color.a);}\n" +
    //--vertical 2-3
    "      vec3 n8 = getNormal(vec3(-0.008568000473088144,-6.209959478273757,4.786485324329855),vec3(0.08682745616842336,4.6642939015984535,5.780252219774349),vec3(0.0,0.0,0.0));\n" +
    "      float d8 = getDistanceToPlane(n8,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d8<tv && fCalloteId==3.0){color.a = min(d8/bv,color.a);}\n" +
    //--vertical 1-2
    "      vec3 n9 = getNormal(vec3(4.4235511989909275,-6.318245350891101,1.4691515683934506),vec3(5.00182887025948,4.951611698435336,1.7489780223412343),vec3(0.0,0.0,0.0));\n" +
    "      float d9 = getDistanceToPlane(n9,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d9<tv && fCalloteId==2.0){color.a = min(d9/bv,color.a);}\n" +
    //--vertical 0-1
    "      vec3 n10 = getNormal(vec3(2.7624310120093063,-6.282996464765596,-3.7100462169305435),vec3(3.092008426550822,4.980853639175175,-4.1617387893133575),vec3(0.0,0.0,0.0));\n" +
    "      float d10 = getDistanceToPlane(n10,vec3(pos.x,pos.y,pos.z));\n" +
    "      if(d10<tv && fCalloteId==1.0){color.a = min(d10/bv,color.a);}\n" +
    "      if(fSmear == 0.0){\n" +
    "         color.a = 1.0;\n" +
    "      }\n" +
    "      gl_FragColor = color;\n" +
    "   }\n";
CustomShader.camPlaneFragmentShader = "#ifdef GL_ES\n" +
    "   precision highp float;\n" +
    "#endif\n" +
    "   varying vec2 vTexCoord;\n" +
    "   uniform sampler2D uTexture;\n" +
    "   uniform float uOpacity;\n" +
    "   void main()\n" +
    "   {\n" +
    "      vec4 color = texture2D(uTexture, vTexCoord);\n" +
    "      color.a = uOpacity;\n" +
    "      if(color.r<0.05 && color.g<0.05 && color.b<0.05)\n" +
    "      {\n" +
    "          color.a=0.0;  \n" +
    "      }\n" +
    "      gl_FragColor = color;\n" +
    "   }\n";
CustomShader.camPlaneVertexShader = "varying vec2 vTexCoord; varying vec4 pos;\n" +
    "\n" +
    "void main()\n" +
    "{\n" +
    "   gl_Position =   projectionMatrix * modelViewMatrix * vec4(position,1.0);\n" +
    "   vTexCoord = uv;\n" +
    "   pos = modelMatrix * vec4(position,1.0);\n" +
    "}\n";
//# sourceMappingURL=custommaterials.js.map